import { T } from 'gt-react';
import { Button } from '@/components/ui/button';
import { useLineSupplyDemand } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';
import { SupplyDemandLines } from '../../components/SupplyDemandLines';

function SupplyLoadError({ onRetry }: { onRetry: () => void }) {
  return (
    <p
      role="alert"
      className="flex items-center gap-2 p-3 text-xs text-muted-foreground"
    >
      <T context="line supply tab: the order lines request failed">
        Couldn't load the order lines.
      </T>
      <Button
        variant="link"
        size="sm"
        className="h-auto p-0 text-xs"
        onClick={onRetry}
      >
        <T context="line supply tab: try loading the order lines again">
          Retry
        </T>
      </Button>
    </p>
  );
}

/**
 * The order lines behind the line's position at its destination (GEN-3285):
 * the open POs and inbound transfers that make On order, and the open sales
 * orders and staged transfers that Net takes off. Read only while the tab is
 * open.
 */
export function LineSupplyTab({
  suggestionId,
  productV3Key,
  now = new Date(),
}: {
  suggestionId: string;
  /** The line's item; open transfers out open the receiver's orders. */
  productV3Key?: string | null;
  now?: Date;
}) {
  const { data, isError, refetch } = useLineSupplyDemand({ suggestionId });
  if (data === undefined) {
    // The board's queries don't retry on their own.
    return isError ? <SupplyLoadError onRetry={() => void refetch()} /> : null;
  }
  return (
    <SupplyDemandLines
      lines={data}
      now={now}
      tree={
        productV3Key
          ? { sku: productV3Key, warehouseId: data.destinationWarehouseId }
          : undefined
      }
    />
  );
}
